import React from "react";
import { withTranslation, useTranslation } from "react-i18next";
import Select from "react-select";
import FloatInput from "../FloatInput";

const FirstStep = (props) => {
  const { t } = useTranslation();
  const handleTitle = (target) => {
    const returnObj = { name: "title", value: target.value };
    props.handleChange({ target: returnObj });
  };
  return (
    <div className="flex flex-col justify-center pt-5">
      <div className="mb-8">
        <p className="type-regular medium">{props.title}</p>
      </div>
      {props.globalError && (
        <div className="mb-8">
          <p className="text-14 text-red-500 pt-6">{props.globalError}</p>
        </div>
      )}
      <div className="flex flex-wrap mb-24">
        <div className="w-2/6">
          <label
            className="text-okkami-husk mb-6 type-title small"
            htmlFor="title"
            style={{ color: props.backgroundColorTopBar }}>
            {t("TITLE")}
            <span className="text-gray-400 type-regular small pl-2">
              {`*${t("REQUIRED")}`}
            </span>
          </label>
          <Select
            id="title"
            name="title"
            className="w-full pr-8 outline-none focus:outline-none type-normal large"
            style={{
              borderColor: props.backgroundColorTopBar,
              background: "transparent",
            }}
            options={props.options}
            components={{ IndicatorSeparator: () => null }}
            isSearchable={false}
            styles={{
              control: (styles) => ({
                ...styles,
                border: "none",
                borderBottom: `1px ${
                  props.backgroundColorTopBar || "#C1C1C1"
                } solid`,
                borderRadius: "0px",
                background: "transparent",
              }),
            }}
            onChange={handleTitle}
            isDisabled={props.disabled}
            defaultValue={{ value: props.getTitle, label: props.getTitle }}
          />
          {props.errors && props.errors["title"] && (
            <p className="text-14 text-red-500 pt-6">
              {props.errors["title"].join(". ")}
            </p>
          )}
        </div>

        <div className="w-4/6 pt-5">
          <FloatInput
            id="firstName"
            name="firstName"
            label={t("FIRSTNAME")}
            span={`*${t("REQUIRED")}`}
            classNameLabel="mb-6 type-title small w-full"
            classNameSpan="text-gray-400 type-regular small pl-2"
            classNameInput="capitalize border-b w-full px-4 rounded-none outline-none focus:outline-none type-normal large md:mb-10"
            onChange={props.handleChange}
            value={props.getFirstName}
            labelColor={props.backgroundColorTopBar}
            borderColor={props.backgroundColorTopBar}
            disabled={props.disabled}
          />
          {props.errors && props.errors["firstName"] && (
            <p className="type-title medium text-red-500 pt-6">
              {props.errors["firstName"].join(". ")}
            </p>
          )}
        </div>
      </div>

      <div className="mb-24">
        <FloatInput
          id="lastName"
          name="lastName"
          label={t("LAST_NAME")}
          span={`*${t("REQUIRED")}`}
          classNameLabel="mb-6 type-title small"
          classNameSpan="text-gray-400 type-regular small pl-2"
          classNameInput="capitalize border-b w-full px-4 rounded-none outline-none focus:outline-none type-normal large md:mb-10"
          onChange={props.handleChange}
          value={props.getLastName}
          labelColor={props.backgroundColorTopBar}
          borderColor={props.backgroundColorTopBar}
          disabled={props.disabled}
        />
        {props.errors && props.errors["lastName"] && (
          <p className="type-title medium text-center text-red-500 pt-6">
            {props.errors["lastName"].join(". ")}
          </p>
        )}
      </div>

      <div className="mb-24 mt-6">
        <FloatInput
          id="email"
          name="email"
          label={t("EMAIL")}
          span={props.allowWithoutEmail ? "" : `*${t("REQUIRED")}`}
          classNameLabel="mb-6 type-title small"
          classNameSpan="text-gray-400 type-regular small pl-2"
          classNameInput="border-b w-full px-4 rounded-none outline-none focus:outline-none type-normal large md:mb-10"
          onChange={props.handleChange}
          value={props.getEmail}
          labelColor={props.backgroundColorTopBar}
          borderColor={props.backgroundColorTopBar}
          disabled={props.disabledEmail}
        />
        {props.errors && props.errors["email"] && (
          <p className="type-title medium text-center text-red-500 pt-6">
            {props.errors["email"].join(". ")}
          </p>
        )}
      </div>
    </div>
  );
};

export default withTranslation()(FirstStep);
